import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async thunk for fetching packages
export const fetchPackages = createAsyncThunk(
  'packages/fetchPackages',
  async (_, { rejectWithValue }) => {
    try {
      // Mevcut API yapısına uygun endpoint
      const response = await axios.get('/website-service/api/App/get-packages');
      return response.data?.data || [];
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Paketler yüklenirken hata oluştu');
    }
  }
);

// Async thunk for package purchase
export const purchasePackage = createAsyncThunk(
  'packages/purchasePackage',
  async (packageData, { rejectWithValue }) => {
    try {
      const response = await axios.post('/api/packages/purchase', packageData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Paket satın alma işlemi başarısız');
    }
  }
);

const packagesSlice = createSlice({
  name: 'packages',
  initialState: {
    packages: [],
    selectedPackage: null,
    loading: false,
    error: null,
    purchaseLoading: false,
    purchaseError: null,
    purchaseSuccess: false,
  },
  reducers: {
    setSelectedPackage: (state, action) => {
      state.selectedPackage = action.payload;
    },
    clearSelectedPackage: (state) => {
      state.selectedPackage = null;
    },
    clearPurchaseState: (state) => {
      state.purchaseLoading = false;
      state.purchaseError = null;
      state.purchaseSuccess = false;
    },
    setPackages: (state, action) => {
      state.packages = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch packages
      .addCase(fetchPackages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPackages.fulfilled, (state, action) => {
        state.loading = false;
        state.packages = action.payload;
        state.error = null;
      })
      .addCase(fetchPackages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Purchase package
      .addCase(purchasePackage.pending, (state) => {
        state.purchaseLoading = true;
        state.purchaseError = null;
        state.purchaseSuccess = false;
      })
      .addCase(purchasePackage.fulfilled, (state, action) => {
        state.purchaseLoading = false;
        state.purchaseSuccess = true;
        state.purchaseError = null;
      })
      .addCase(purchasePackage.rejected, (state, action) => {
        state.purchaseLoading = false;
        state.purchaseError = action.payload;
        state.purchaseSuccess = false;
      });
  },
});

export const { 
  setSelectedPackage, 
  clearSelectedPackage, 
  clearPurchaseState,
  setPackages 
} = packagesSlice.actions;

// Selectors
export const selectPackages = (state) => state.packages.packages;
export const selectSelectedPackage = (state) => state.packages.selectedPackage;
export const selectPackagesLoading = (state) => state.packages.loading;
export const selectPackagesError = (state) => state.packages.error;
export const selectPurchaseLoading = (state) => state.packages.purchaseLoading;
export const selectPurchaseError = (state) => state.packages.purchaseError;
export const selectPurchaseSuccess = (state) => state.packages.purchaseSuccess;

export default packagesSlice.reducer; 